import React from 'react';
import PropTypes from 'prop-types';
import { mergeClasses } from '@fluentui/react-components';
import { EmptyViewIcons } from '@bingads-webui-campaign-react/ads-studio-app-shared-components';

import { useImageEmptyViewStyle } from '../../styles';

export const ImageEmptyView = ({ i18n, isSearchResult }) => {
  const classes = useImageEmptyViewStyle(); // Correct placement of classes initialization

  return (
    <div className={classes.emptyView}>
      <div className={classes.emptyIcon}>
        <img src={EmptyViewIcons.ImageEmptyViewSVG} alt="Empty Icon" />
      </div>
      <div className={mergeClasses('no-image', classes.mainText)}>
        {isSearchResult ? i18n.getString(_TL_('No images match your search. Please try again.')) : i18n.getString(_TL_('You haven\'t added any images yet. Choose from the options above to add images.'))}
      </div>
    </div>
  );
};

ImageEmptyView.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  isSearchResult: PropTypes.bool,
};

ImageEmptyView.defaultProps = {
  isSearchResult: false,
};
